import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { SubCompanyDto } from '../../../models/dtos/subCompany.dto';
import { Errors } from '../../errors';
import getSubCompaniesRequest from './getSubCompanies.repository';

type InitialState = {
  loading: boolean;
  data?: SubCompanyDto[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getSubCompanies = createAsyncThunk<
  SubCompanyDto[],
  void,
  { rejectValue: ReturnType<typeof Errors.getErrorDtoFromApiError> }
>('getSubCompanies', async (_, { rejectWithValue, dispatch }) => {
  try {
    return await getSubCompaniesRequest();
  } catch (error: any) {
    return rejectWithValue(error);
  }
});

const getSubCompaniesSlice = createSlice({
  name: 'getSubCompanies',
  initialState,
  reducers: {
    getSubCompaniesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSubCompanies.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getSubCompanies.fulfilled,
      (state, action: PayloadAction<SubCompanyDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getSubCompanies.rejected, (state, action) => {
      state.loading = false;
      console.log('ACTION: ', action.payload);
      console.log(Errors.getErrorDtoFromApiError(action.payload));
      state.error = Errors.getErrorDtoFromApiError(action.payload);
    });
  },
});

export default getSubCompaniesSlice.reducer;
export const { getSubCompaniesReset } = getSubCompaniesSlice.actions;
